export class ScaleRange
{
	private _id:string;
	private _rangeStart:number;
	private _rangeEnd:number;
	private _name:string;
	private _displayName:string;
	private _content:string;
	private _mediaURL:string;
	private _mediaType:string;
	private _assignmentURL:string;
	private _clientDisplayName:string;
	private _clientContent:string;
	
	constructor() {
		this.id = null;
		this.rangeStart = 0;
		this.rangeEnd = 0;
		this.name = "";
		this.displayName = "";
		this.clientContent = "";
		this.therapistContent = "";
		// for now we go to video... if we change to anything
		// else we can handle it from this flag.
		this.mediaType = "video";
		this.mediaURL = null;
		this.assignmentURL = null;
	}
	
	
	public get id() : string {
		return this._id;
	}
	
	public set id(v : string) {
		this._id = v;
	}
	
	public get mediaType() : string {
		return this._mediaType;
	}
	
	public set mediaType(v:string) {
		this._mediaType = v;
	}
	
	public get mediaURL() : string {
		return this._mediaURL;
	}
	
	public set mediaURL(v : string) {
		this._mediaURL = v;
	}

	public hasMedia() {
		return this._mediaType == 'video' && this._mediaURL;
	}
	
	
	public get assignmentURL() : string {
		return this._assignmentURL;
	}
	
	
	public set assignmentURL(v : string) {
		this._assignmentURL = v;
	}
	
	
	public get midPoint() : number {
		let mid = this.rangeStart + Math.ceil(Math.abs(this.rangeEnd - this.rangeStart) / 2);
		return mid;
	}

	public getPercentageForRange(score:number) {
		let minRange = this.rangeStart;
		let maxRange = this.rangeEnd;

		if (score < minRange || score > maxRange) {
			throw new Error("Score(" + score + ") is out of range(" + minRange + "," + maxRange + ")");
		}

		// we make it inclusive and start our scores off one based if the rangeStart is a 0
		
		
		// if (minRange > 0) {
		// 	// we are inclusive so we are adding one to the endInterval
		// 	maxRange += 1;
		// }

		let maxInterval = Math.max(maxRange - minRange, 1);
		let interval = score - minRange;
		let normalizedPercentage = 0;
		// NOTE: APSATS request, if the interval range is only 1, and a user scores a 0 value we want the graph to show in the middle
		// instead of at the very beginning of the range.
		if (maxInterval == 1) {
			normalizedPercentage = interval == 0 ? 50 : 100;
		}
		else {
			normalizedPercentage = Math.round((interval / maxInterval) * 100);
		}
		return normalizedPercentage;

	}
	
	public get rangeStart() : number {
		return this._rangeStart;
	}
	
	public set rangeStart(v : number) {
		this._rangeStart = v;
	}
	public get rangeEnd() : number {
		return this._rangeEnd;
	}
	
	public set rangeEnd(v : number) {
		this._rangeEnd = v;
	}
	
	public get name() : string {
		return this._name;
	}
	
	public set name(v : string) {
		this._name = v;
	}
	
	public get displayName() : string {
		return this._displayName;
	}
	
	public set displayName(v : string) {
		this._displayName = v;
	}
	
	public get therapistContent() : string {
		return this._content;
	}
	
	public set therapistContent(v : string) {
		this._content = v;
	}


	public get clientContent(): string {
		return this._clientContent;
	}

	public set clientContent(value: string) {
		this._clientContent = value;
	}
	
}


// WEBPACK FOOTER //
// ./src/app/shared/models/scale-range.ts